<template>
<div v-if="data_competences">
<div v-if="isLoading" class="loading">Loading&#8230;</div> 


<div class="columns is-gapless has-background-white">
<div class="column is-3 mt-2 has-text-weight-bold is-size-4">&nbsp;&nbsp;COMPETENCES</div>

<div class="column is-2">
<div class="columns is-gapless">  
  <div class="column is-10 control has-icons-left">
    <input  v-model="search" @keyup.enter="get_competences()" class="input is-fullwidth has-text-weight-bold" type="text" placeholder="search code">
    <span class="icon is-small is-left"><i class="fas fa-search" aria-hidden="true"></i></span>
  </div>

  <div class="column is-2 has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
      <button @click="filter_search_clear()" class="button has-background-danger-light"><span class="icon is-small has-text-grey"> <i class="fas fa-times"></i> </span></button>
  </div>

</div></div>

<div class="column is-1"></div>

<div class="column is-3">
<div class="columns is-gapless"> 

<div class="column is-2 is-size-7 has-text-right has-text-weight-bold">Filter&nbsp;&nbsp;<br>Program&nbsp;&nbsp;</div>
<div class="column is-8">
    <div class="select is-info is-fullwidth has-text-weight-bold">
        <select  @change="filter_program()" id="program" class="has-text-weight-bold has-text-danger" v-model="prog_id">
                <option v-for="(choice,index) in data_programs" :value="choice.prog_ID" :key="index">{{ choice.prog_CODE }} : {{choice.prog_CODEPLUS}}</option>
        </select>
    </div>                
</div>

  <div class="column is-2 has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
      <button @click="filter_program_clear()" class="button has-background-danger-light"><span class="icon is-small has-text-grey"> <i class="fas fa-times"></i> </span></button>
  </div>

</div></div>

<div class="column is-1"></div>

    <div class="column is-2">
        <button @click="competence_new()" class="button is-fullwidth has-background-success has-text-white">
            <span class="icon"><i class="fas fa-plus"></i></span>     
        </button> 
    </div>

</div>









<!-- CHECK IF ADDING NEW  -->
<!-- <div v-if="data_competences[0].comp_ID == 0" class="columns is-gapless" style="margin-bottom:0em;">
    <div class="column is-size-5 has-text-weight-bold is-12 has-background-success">
        NEW COMPETENCE
    </div>
</div> -->

<div class="columns is-centered is-multiline is-gapless">
<div class="column is-6" style="margin-bottom:.8em;" v-for="(data,index) in data_competences" :key="index">


<!-- //COMPETENCES  -->
<div class="columns is-centered is-multiline  is-gapless">
<div class="column is-1"></div>
<div class="column colBorderThin is-2">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="data_competences[index].isChanged = true" v-model="data_competences[index].comp_CODE" placeholder="Comp Code" class="input has-background-light is-fullwidth"> 
    </div>
</div></div>

<div class="column colBorderThin is-7">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="data_competences[index].isChanged = true" v-model="data_competences[index].comp_TITRE_F" placeholder="French" class="input is-fullwidth"> 
    </div>
    <div class="column is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="data_competences[index].isChanged = true" v-model="data_competences[index].comp_TITRE_E" placeholder="English" class="input is-fullwidth"> 
    </div>

</div></div>

<div class="column colBorderThin is-1">
<div class="columns is-gapless is-multiline">

  <div class="column has-text-right is-12 has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
    <button @click="competence_delete_confirm(index,data_competences[index].comp_CODE)" class="button is-fullwidth"><span class="icon is-small has-text-danger-light"> <i class="fas fa-trash-alt"></i> </span></button>
  </div> 


 <!-- PROGRAM SAVE  -->
    <div v-if="+data_competences[index].isChanged" class="column has-text-centered is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;"> 
      <button @click="competence_save(index)" class="button is-success is-fullwidth"><span class="icon is-small has-text-white"> <i class="fas fa-save"></i> </span>&nbsp;&nbsp;&nbsp;SAVE</button>
    </div>

</div></div>

<div class="column is-1"></div>


<!-- <div v-if="data_competences[index].showDetails" class="column is-12" style="margin-bottom:2em;">

<div class="columns is-centered is-vcentered is-gapless is-multiline" style="margin-bottom:0em;"> 
    <div class="column is-1">
        <button @click="get_courses()" class="button is-fullwidth has-background-success has-text-white">
            <span class="icon"><i class="fas fa-plus"></i></span>     
        </button> 
    </div>
    <div class="column is-2 is-size-7 has-text-weight-bold has-text-success">&nbsp;&nbsp;&nbsp;ADD COURSE</div>
    <div v-if="!new_cour_show" class="column is-9"></div>


<div v-if="new_cour_show" class="column is-2">
        <div class="control">
        <div class="select is-fullwidth">
            <select  v-model="new_cour_id">
                <option v-for="(data,index) in data_courses" :value="data.cour_ID"  :key="index" >{{ data.cour_CODE }}</option>
            </select>
        </div>
        </div>
</div>

<div v-if="new_cour_show" class="column is-2">
    <div class="columns is-gapless">
        <div class="column colBorder is-4">
            <button @click="new_cour_show=false" class="button has-text-danger is-fullwidth"><span class="icon is-small has-text-grey"> <i class=" has-text-danger fas fa-window-close"></i> </span></button>
        </div>
        <div class="column colBorder is-8">
            <button @click="competence_add_course()" class="button has-text-success is-fullwidth"><span class="icon is-small has-text-grey"> <i class=" has-text-success fas fa-check-circle"></i> </span>&nbsp;&nbsp;&nbsp;ADD</button>
        </div>
    </div>
</div>




    <div class="column is-5"></div>

    <div class="column is-10">
    <CompPedCourse :prog_id='0' :comp_id='comp_id' :key="compKey"> </CompPedCourse>
    </div>

</div></div> -->


</div>

</div></div>


</div>
</template>

<script>
import axios from 'axios'
import CompPedCourse from "@/views/Admin/Comp_Admin_Ped_Course"

export default {
  name: 'PedCompetences',
  props: [ ],
  components: {CompPedCourse},

    data() {
        return {
            isLoading:false,
            search:'',
            prog_id:-1,
            data_competences:[],
            data_courses:[], // FOR ADDING TO COMP
            data_programs:[],
            show_courses:false,
            comp_id:0,
            new_cour_id:0,
            new_cour_show:false,

            compKey: 0, // REFRESH COMPONENT

        }
    },

// "INSERT INTO MyMEQ_RELATION (prog_ID, comp_ID, cour_ID) VALUES (" & iProgID & "," & iCOMP & "," & .GetData(iX, 0).ToString & ")"

created() {

    this.isLoading=true;
    // GET PROGRAMS
    var sql = "SELECT * FROM MyMEQ_PROGRAM WHERE prog_ACTIVE = 1 ORDER BY prog_TITRE_F"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
        this.data_programs = res.data
        this.isLoading=false;  
        this.get_competences() 
      })

    
},

methods: {

filter_search_clear:function() {
  this.search = ''
  this.get_competences()
},

filter_program_clear:function() {
  this.prog_id = -1
  this.get_competences()
},

filter_program:function() {
var index = document.getElementById("program").selectedIndex
  this.prog_id = this.data_programs[index].prog_ID
  this.get_competences()
},



competence_add_course:function() {
// ADD COURSE TO COMPETENCE 
var query = "INSERT INTO MyMEQ_COMPETENCE_DETAILS (comp_ID, cour_ID) VALUES (" + this.comp_id + "," + this.new_cour_id + ")"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
    this.compKey = ++this.compKey + 1
    this.new_cour_show=false
});

},



competence_new:function() {
// CALLED FROM ADMIN_PED !!!!

// CHECK IF NOTHING
if (this.data_competences.length == 0) {
  this.data_competences.unshift({comp_ID:0 , isChanged:0 , doDelete:0,showDetails:0 ,comp_CODE:'',comp_TITRE_F:'',comp_TITRE_E:''})
  return;
}

if (this.data_competences[0].comp_ID == 0) {return;}// CHECK IF ALREADY ONE NEW
  this.data_competences.unshift(
    {comp_ID:0 , isChanged:0 , doDelete:0,showDetails:0 ,comp_CODE:'',comp_TITRE_F:'',comp_TITRE_E:''}
  )
},

get_competences:function() {
    this.isLoading = true;

var querySearch1 = ''
var querySearch2 = ''
if (this.search.trim() != '') {
    querySearch1 = " AND comp_CODE LIKE '%25" + this.search + "%25' "
    querySearch2 = " WHERE comp_CODE LIKE '%25" + this.search + "%25' "
}


var query = ''
if (this.prog_id != -1) {query = "SELECT distinct MyMEQ_COMPETENCE.comp_ID, comp_CODE, comp_TITRE_F, comp_TITRE_E, 0 as isChanged, 0 as doDelete, 0 as showDetails FROM MyMEQ_RELATION INNER JOIN MyMEQ_COMPETENCE ON MyMEQ_RELATION.comp_ID = MyMEQ_COMPETENCE.comp_ID WHERE prog_ID = " + this.prog_id + querySearch1 + "  ORDER BY comp_CODE"}
else {query = "SELECT distinct *, 0 as isChanged, 0 as doDelete, 0 as showDetails FROM myMEQ_COMPETENCE " + querySearch2 + " ORDER BY comp_CODE"} 
console.log(query)
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_competences = res.data
        this.isLoading = false;
    });

},

competence_save:function(index) {

var query
if (this.data_competences[index].comp_ID == 0) {
  // INSERT
      query = "INSERT INTO myMEQ_COMPETENCE (comp_CODE) VALUES ('');SELECT MAX(comp_ID) AS newID FROM myMEQ_COMPETENCE"
      axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
      .then(res => { 
          this.data_competences[index].comp_ID = res.data[0].newID

          query = "UPDATE myMEQ_COMPETENCE SET " 
          query +=  " comp_CODE = '" + this.data_competences[index].comp_CODE
          query +=  "', comp_TITRE_F = '" + this.data_competences[index].comp_TITRE_F.trim().replace(/'/g,"''")
          query +=  "', comp_TITRE_E = '" + this.data_competences[index].comp_TITRE_E.trim().replace(/'/g,"''")
          query +=  "' WHERE comp_ID = " + this.data_competences[index].comp_ID
 
console.log(query)

          axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
          .then(res => { 
              this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
              this.data_competences[index].isChanged = false
          });
  });
}
else // UPDATE
{ 
          query = "UPDATE myMEQ_COMPETENCE SET " 
          query +=  " comp_CODE = '" + this.data_competences[index].comp_CODE
          query +=  "', comp_TITRE_F = '" + this.data_competences[index].comp_TITRE_F.trim().replace(/'/g,"''")
          query +=  "', comp_TITRE_E = '" + this.data_competences[index].comp_TITRE_E.trim().replace(/'/g,"''")
          query +=  "' WHERE comp_ID = " + this.data_competences[index].comp_ID
console.log(query)
          axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
          .then(res => { 
              this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
              this.data_competences[index].isChanged = false
          });

}

},
// END SAVE 



competence_get_courses:function(index) {
    if (this.data_competences[index].showDetails == true) {this.data_competences[index].showDetails = false; this.new_cour_show=false ; return ; }
    this.data_competences[index].showDetails = true 
    this.comp_id = this.data_competences[index].comp_ID
},

get_courses:function() {
    this.isLoading = true;
// GET LIST OF COURSES FOR ADDING TO POND ....
var query = "SELECT * FROM myMEQ_COUR ORDER BY cour_CODE"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
        this.data_courses = res.data
        this.isLoading = false;
        this.new_cour_id = 0
        this.new_cour_show = true; 
});

},



competence_delete_confirm:function(index, comp) {

// CHECK IF COMP ASSOCIATED TO PROGRAM -- IF SO, NO DELETE
    var query = "SELECT * FROM MyMEQ_RELATION WHERE comp_ID = " + this.data_competences[index].comp_ID  
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 

        if (!res.data[0]) {
                this.$snotify.confirm("Delete Competence " + this.data_competences[index].comp_CODE + "?" , { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
                position: "centerCenter",
                    buttons: [
                        {text: 'Yes', action: (toast) => this.competence_delete_execute(index,toast)},
                        {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
                    ]
                });
        } else {
            alert ('Competence is in use! To delete this competence, please delete all instances in your Programs.')
        }
    });

},



competence_delete_execute:function(index, toast) {
this.$snotify.remove(toast.id)
var query
    // JUST DELETE THE COMP 
  // CHECK IF NOT SAVED
  if (this.data_competences[index].comp_ID == 0) {this.data_competences.splice(index,1); return;}
  query = "DELETE FROM myMEQ_COMPETENCE WHERE comp_ID = " + this.data_competences[index].comp_ID
  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
  .then(res => { 
      this.data_competences.splice(index,1)
      this.$snotify.success('DELETED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
  });




},


} // END METHODS




} // END EXPORT
</script>